import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export const inputCls = "w-full rounded-xl bg-white border border-warm px-4 py-3 focus:outline-none focus:border-terracotta focus:ring-1 focus:ring-terracotta";
export const labelCls = "text-xs uppercase tracking-[0.2em] font-semibold text-charcoal/60 mb-2 block";

export const AuthShell = ({ testId, title, subtitle, backTestId, children }) => (
  <div className="min-h-screen bg-linen flex items-center justify-center px-5 py-10" data-testid={testId}>
    <div className="w-full max-w-md bg-white/70 backdrop-blur-xl border border-warm rounded-3xl p-6 sm:p-10 shadow-sm animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="w-11 h-11 rounded-2xl rose-glow flex items-center justify-center mb-6 shadow-lg text-white">
        <Sparkles className="w-5 h-5" strokeWidth={2} />
      </div>
      <h1 className="font-display text-3xl sm:text-4xl mb-2 text-charcoal">{title}</h1>
      <p className="text-charcoal/70 mb-8 text-sm sm:text-base">{subtitle}</p>
      {children}
      <p className="text-sm text-charcoal/60 text-center mt-8">
        <Link to="/login" className="terracotta font-semibold" data-testid={backTestId}>← Back to sign in</Link>
      </p>
    </div>
  </div>
);
